import type { IconType } from 'react-icons';
import { LuShieldCheck, LuStar, LuTimer, LuUsers } from 'react-icons/lu';

export type SbrImpactStat = {
  value: string;
  label: string;
  Icon: IconType;
};

export const SBR_IMPACT_STATS: SbrImpactStat[] = [
  { value: '95%+', label: 'Technical/Niche roles filled', Icon: LuUsers },
  { value: '47 Days', label: 'Average time-to-hire', Icon: LuTimer },
  { value: '96%', label: 'Stick rate', Icon: LuStar },
  { value: '75%', label: 'Repeat client business', Icon: LuShieldCheck },
];
